export function Spinner() {
  return (
    <svg
      className="pa-spinner"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
    >
      <path d="M12 2 a10 10 0 0 1 10 10" strokeLinecap="round" />
    </svg>
  );
}
